const addNoOpenerToAnchors = (htmlString) => {
  if (typeof window !== 'undefined' && typeof window.DOMParser !== 'undefined') {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    
    // Extracting content within the body tag
    const bodyContent = doc.querySelector('body').innerHTML;

    const bodyDoc = new DOMParser().parseFromString(bodyContent, 'text/html');
    const anchors = bodyDoc.querySelectorAll('a');
    
    anchors.forEach((anchor) => {
      const targetBlank = anchor.getAttribute('target') === '_blank';
      const isExternal = !anchor.href.startsWith('https://www.motivosity.com') && !anchor.href.startsWith('/');

      if (targetBlank && isExternal) {
        anchor.setAttribute('rel', 'noopener');
      }
    });

    return bodyDoc.body.innerHTML; // Return the modified content within the body tag
  }
};

export default addNoOpenerToAnchors;
